import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const updateCategoryAction = createAsyncThunk(
  "update-category",
  async (data = null, { rejectWithValue }) => {
    try {
      const { isPublisherCategory, ...payload } = data || {};
      const response = isPublisherCategory
        ? await axios.put(`/admin/publisher/category/update`, {
            category_id: payload?.category_id,
            name: payload?.name,
            cashback_percentage: payload?.cashback_percentage,
            position: payload?.position,
            image: payload?.image,
            is_popular_category: payload?.is_popular_category,
          })
        : await axios.put(`/admin/product/category`, {
            catId: payload?.catId,
            name: payload?.name,
            cashback_percentage: payload?.cashback_percentage,
            position: payload?.position,
            image: payload?.image,
            popular_category: payload?.popular_category,
          });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const updateCategorySlice = createSlice({
  name: "update-category",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(updateCategoryAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCategoryAction.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      if(state.status==401){
        localStorage.clear()
      }
      state.data = action.payload?.response;
    });
    builder.addCase(updateCategoryAction.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      state.error = action.error.message;
    });
  },
});

export const updateCategoryReducer = updateCategorySlice.reducer;
